<div class="double-carousel">
  <div class="landscape-cards-wrapper">
    <app-horizontal-scroller [itemType]="CarouselItems.Landscape">
      <div class="scroll-wrapper">
        <div class="cards-container">
          @for(landscape of landscapes; track $index){
          <a [routerLink]="['/browse/search']" [queryParams]="{ tag: landscape.id }" class="card-container">
            <app-simple-card class="pointer" [item]="landscape">
            </app-simple-card>
          </a>
          }
        </div>
      </div>
    </app-horizontal-scroller>
  </div>
  <div class="region-cards-wrapper">
    <app-horizontal-scroller [itemType]="CarouselItems.Region">
      <div class="scroll-wrapper">
        <div class="cards-container">
          @for(region of regions; track $index){
          <a [routerLink]="['/browse/search']" [queryParams]="{ country: region.name }" class="card-container">
            <app-simple-card class="pointer" [item]="region" [isRegion]="true" />
          </a>
          }
        </div>
      </div>
    </app-horizontal-scroller>
  </div>
</div>